import React, { useEffect, useState } from 'react';

import { useEmpresa } from '../lib/empresas';
import { db } from '../lib/firebase';

function ReferralFormApp({ companyId }) {
  // Vale a empresa que existe no banco e está ativa. Antes isso era uma lista
  // fixa no código, e cliente novo só entrava com deploy.
  const { empresa: company, carregando: carregandoEmpresa } = useEmpresa(companyId);
  const [companyExists, setCompanyExists] = React.useState(null); // null=carregando
  const [submitted, setSubmitted] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState('');

  const blank = {
    consultant_name: '',
    company_name: '',
    contact_name: '',
    contact_phone: '',
    contact_email: '',
    website: '',
    summary: '',
    qualification: 3,
  };
  const [form, setForm] = React.useState(blank);
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  React.useEffect(() => {
    if (!companyId) { setCompanyExists(false); return; }
    if (carregandoEmpresa) return;
    setCompanyExists(!!company);
  }, [companyId, company, carregandoEmpresa]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.consultant_name.trim() || !form.company_name.trim()) return;
    setSaving(true); setError('');
    try {
      await db.collection('companies').doc(companyId).collection('referrals').add({
        ...form,
        qualification: Number(form.qualification),
        status: 'pending',
        created_at: new Date().toISOString(),
      });
      setSubmitted(true);
    } catch(e) {
      setError('Erro ao enviar. Tente novamente.');
    }
    setSaving(false);
  };

  const qualLabels = ['', 'Muito frio ❄️', 'Frio 🌥', 'Morno 🌤', 'Quente 🔥', 'Muito quente 🚀'];
  const qualColors = ['', 'bg-blue-100 text-blue-700', 'bg-blue-50 text-blue-500', 'bg-yellow-50 text-yellow-600', 'bg-orange-100 text-orange-600', 'bg-red-100 text-red-600'];
  const inp = 'apple-input w-full px-3 py-2.5 text-sm';
  const accentColor = company?.color === 'red' ? '#DC2626' : company?.color === 'orange' ? '#F97316' : '#2563EB';

  if (companyExists === null) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="w-6 h-6 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"/>
    </div>
  );

  if (!companyExists) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="text-center">
        <div className="text-5xl mb-4">🔗</div>
        <h2 className="text-lg font-semibold text-gray-800 mb-2">Link inválido</h2>
        <p className="text-sm text-gray-500">Este link de indicação não existe ou foi desativado.</p>
      </div>
    </div>
  );

  if (submitted) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="text-center max-w-sm animate-fade-in-up">
        <div className="text-6xl mb-4">🎉</div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Indicação enviada!</h2>
        <p className="text-sm text-gray-500 mb-6">Obrigado pela indicação! Nossa equipe irá analisar e entrar em contato em breve.</p>
        <button
          onClick={() => { setForm(blank); setSubmitted(false); }}
          className="px-5 py-2.5 rounded-xl text-sm font-semibold text-white transition-all"
          style={{ backgroundColor: accentColor }}
        >
          Enviar outra indicação
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-black/[0.07] px-4 py-4 flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center text-white font-bold text-sm"
          style={{ backgroundColor: accentColor }}>
          {(company?.label || companyId).charAt(0).toUpperCase()}
        </div>
        <div>
          <div className="t-footnote font-semibold text-gray-900">{company?.label || companyId}</div>
          <div className="t-caption-2 text-gray-400">Formulário de Indicação</div>
        </div>
      </div>

      {/* Form */}
      <div className="max-w-md mx-auto px-4 py-6">
        <div className="acard rounded-2xl p-5 shadow">
          <h1 className="text-base font-bold text-gray-900 mb-1">Indicar um cliente</h1>
          <p className="text-xs text-gray-400 mb-5">Preencha os dados abaixo para indicar um potencial cliente para nossa equipe.</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Consultor */}
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1.5 block">👤 Seu nome (consultor) *</label>
              <input
                required className={inp} placeholder="Seu nome completo"
                value={form.consultant_name}
                onChange={e => set('consultant_name', e.target.value)}
              />
            </div>

            <div className="border-t border-gray-100 pt-4">
              <p className="t-caption-2 font-bold text-gray-400 sf-caption mb-3">🏢 Dados da empresa indicada</p>

              <div className="space-y-3">
                <input required className={inp} placeholder="Nome da empresa *"
                  value={form.company_name} onChange={e => set('company_name', e.target.value)} />

                <div className="grid grid-cols-2 gap-2">
                  <input className={inp} placeholder="Nome do contato"
                    value={form.contact_name} onChange={e => set('contact_name', e.target.value)} />
                  <input className={inp} placeholder="Telefone / WhatsApp"
                    value={form.contact_phone} onChange={e => set('contact_phone', e.target.value)} />
                </div>

                <input className={inp} placeholder="E-mail" type="email"
                  value={form.contact_email} onChange={e => set('contact_email', e.target.value)} />

                <input className={inp} placeholder="Site (opcional)"
                  value={form.website} onChange={e => set('website', e.target.value)} />
              </div>
            </div>

            {/* Resumo */}
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-1.5 block">📝 O que você identificou neste cliente?</label>
              <textarea className={inp + ' resize-none'} rows={3}
                placeholder="Descreva a dor ou oportunidade que você identificou..."
                value={form.summary} onChange={e => set('summary', e.target.value)} />
            </div>

            {/* Qualificação */}
            <div>
              <label className="text-xs font-semibold text-gray-600 mb-2 block">🌡 Temperatura do lead</label>
              <div className="flex gap-1.5">
                {[1,2,3,4,5].map(n => (
                  <button
                    key={n} type="button"
                    onClick={() => set('qualification', n)}
                    className={`flex-1 py-2 rounded-xl text-xs font-bold border-2 transition-all ${
                      form.qualification >= n
                        ? 'border-transparent ' + qualColors[n]
                        : 'border-gray-200 text-gray-300 bg-white'
                    }`}
                  >
                    {n}
                  </button>
                ))}
              </div>
              <p className={`text-xs font-medium mt-1.5 ${qualColors[form.qualification]?.split(' ')[1] || 'text-gray-500'}`}>
                {qualLabels[form.qualification]}
              </p>
            </div>

            {error && <p className="text-xs text-red-500 bg-red-50 px-3 py-2 rounded-lg">{error}</p>}

            <button
              type="submit" disabled={saving}
              className="w-full py-3 rounded-xl text-sm font-semibold text-white transition-all disabled:opacity-60"
              style={{ backgroundColor: accentColor }}
            >
              {saving ? 'Enviando...' : 'Enviar indicação →'}
            </button>
          </form>
        </div>

        <p className="text-center t-caption-2 text-gray-400 mt-4">
          Suas informações são confidenciais e usadas apenas para contato comercial.
        </p>
      </div>
    </div>
  );
}

// ─── LoginScreen ──────────────────────────────────────────
// ─── Toast ────────────────────────────────────────────────

export { ReferralFormApp };
